import { useParams } from 'react-router-dom';
import { UserProfile } from '../../components/UserProfile';

export function UserDetailsPage() {
  const { id } = useParams<{ id: string }>();
  
  return <UserProfile userId={id} showBackButton showAdminControls />;
}

export default UserDetailsPage;
